import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  push,
  replace
} from 'react-router-redux';
import {
  Container,
  Header,
  Icon,
  List,
  Segment
} from 'semantic-ui-react';
import {
  Link
} from 'react-router-dom';
import {
  Route
} from 'react-router-dom';
import feathersConnect from './../../providers/feathersConnect';
import DynamicRichTextSection from './DynamicRichTextSection';

class TramitesView extends Component {

  constructor (props) {
    super(props);
  }

  componentDidMount () {

  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    return (
      <Container fluid>
        <Container style={{ padding: 16 }}>
          <Header as="h2">
            <Icon name="users" />
            <Header.Content>
              Tramites
              <Header.Subheader>
                Guia de Tramites
              </Header.Subheader>
            </Header.Content>
          </Header>
          <List divided relaxed>
            <List.Item>
              <List.Icon name="book" size="large" verticalAlign="middle" />
              <List.Content>
                <List.Header as={Link} to="/tramites/sellados">Sellados</List.Header>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Icon name="book" size="large" verticalAlign="middle" />
              <List.Content>
                <List.Header as={Link} to="/tramites/formacion">Formacion de Cooperativas</List.Header>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Icon name="book" size="large" verticalAlign="middle" />
              <List.Content>
                <List.Header as={Link} to="/tramites/libros">Libros</List.Header>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Icon name="book" size="large" verticalAlign="middle" />
              <List.Content>
                <List.Header as={Link} to="/tramites/asambleas">Asambleas</List.Header>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Icon name="book" size="large" verticalAlign="middle" />
              <List.Content>
                <List.Header as={Link} to="/tramites/asistencia">Asistencia Financiera</List.Header>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Icon name="book" size="large" verticalAlign="middle" />
              <List.Content>
                <List.Header as={Link} to="/tramites/emision">Emision de constancias y certificados</List.Header>
              </List.Content>
            </List.Item>
          </List>
          <Route path="/tramites/sellados" render={() => {
            return (
              <Segment>
                <DynamicRichTextSection sectionName="sellados" />
              </Segment>
            );
          }} />
          <Route path="/tramites/formacion" render={() => {
            return (
              <Segment>
                <DynamicRichTextSection sectionName="formacion" />
              </Segment>
            );
          }} />
          <Route path="/tramites/libros" render={() => {
            return (
              <Segment>
                <DynamicRichTextSection sectionName="libros" />
              </Segment>
            );
          }} />
          <Route path="/tramites/asambleas" render={() => {
            return (
              <Segment>
                <DynamicRichTextSection sectionName="asambleas" />
              </Segment>
            );
          }} />
          <Route path="/tramites/asistencia" render={() => {
            return (
              <Segment>
                <DynamicRichTextSection sectionName="asistencia" />
              </Segment>
            );
          }} />
          <Route path="/tramites/emision" render={() => {
            return (
              <Segment>
                <DynamicRichTextSection sectionName="emision" />
              </Segment>
            );
          }} />
        </Container>

        <Container className="bg-green-dust" fluid style={{ backgroundColor: '#72bd4b', padding: 16, height: 200 }}>

        </Container>
      </Container>
    );
  }
}

export default feathersConnect(
  connect(
    TramitesView.mapStateToProps,
    TramitesView.mapDispatchToProps
  )(TramitesView)
);



// WEBPACK FOOTER //
// ./client/components/pages/TramitesView.js